import { render, staticRenderFns } from "./CompanyDetailsForm.vue?vue&type=template&id=9407f4c0&scoped=true"
import script from "./CompanyDetailsForm.vue?vue&type=script&lang=ts"
export * from "./CompanyDetailsForm.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDetailsForm.vue?vue&type=style&index=0&id=9407f4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9407f4c0",
  null
  
)

export default component.exports